import React from "react";
import Portal from "../../Portal";
import x from "../../shared/icons/x.svg";
import { notify } from "../../shared/alertToastify";
import { useHistory } from "react-router-dom";

export default function AdminModal({ modal, setModal, closeModal }) {
    const history = useHistory();
    function goMyPage() {
        closeModal();
        history.push("/mypage");
    }

    return (
        <Portal>
            <div className="h-max w-[50%] bg-white fixed top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-[99] p-[20px]">
                <button
                    onClick={closeModal}
                    className="absolute top-0 -right-20"
                >
                    <img src={x} alt="닫기버튼" />
                </button>
                <h3 className="font-['decimal_book'] text-[40px] mb-[30px]">
                    ADMIN
                </h3>
                <button
                    className="bg-[#d2d2d2] border border-solid w-full p-[15px] font-['decimal_book'] text-[20px] "
                    onClick={goMyPage}
                >
                    MY PAGE
                </button>
                <div className="grid grid-cols-2 gap-x-[30px] gap-y-[20px] py-[20px]">
                    <Link link="/dataTagAdmin">DATA TAG ADMIN</Link>
                    <Link link="/priceTagSystem/list">PRICE TAG SYSTEM</Link>
                    <Link link="/portfolioFinder/list">PORTFOLIO FINDER</Link>
                    <button
                        onClick={() => notify("준비중입니다", "info")}
                        className="font-['decimal_book'] text-[20px] bg-black text-white p-[10px] text-center cursor-pointer"
                    >
                        LIFESTYLE SYNC
                    </button>
                    {/* <Link link="">IMAGE SYNC</Link> */}
                    <Link link="/board">BOARD</Link>
                    <Link link="/file">FILE</Link>
                </div>
                {/* <a
                    type="button"
                    target="_blank"
                    className="bg-black text-white w-full p-[15px] font-['decimal_book'] text-[20px] text-center"
                    href={"/priceTagSystem/admin"}
                >
                    PRICE TAG SYSTEM ESTIMATE
                </a> */}
            </div>
            <div
                className="fixed h-[100%] w-[100%] bg-black opacity-80 top-0 left-0 cursor-pointer z-[90]"
                onClick={closeModal}
            />
        </Portal>
    );
}

function Link({ link, children }) {
    return (
        <a
            className="font-['decimal_book'] text-[20px] bg-black text-white p-[10px] text-center cursor-pointer"
            type="button"
            target="_blank"
            href={link}
        >
            {children}
        </a>
    );
}
